export default {
      id: "ic_bahista_probability_surprise-usage",
      viewBox: "0 0 27 16",
      url: "/" + "images/icons.3.109.2.svg#ic_bahista_probability_surprise-usage",
      toString: function () {
        return this.url;
      }
    }